import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { UncontrolledTooltip } from 'reactstrap';
import { Button } from 'react-bootstrap';
import { dateToString } from '../../common/utils/date/Date.utils';
import { preparePriceFormat } from '../../helpers/preparePriceFormat';
import { formatOrganizationLocation } from '../../helpers/formatOrganizationLocation';
import { BidStatus, BidStatusName } from '../../constants/BidStatus';
import { pencesToPounds } from '../../common/helpers/pencesToPounds';
import { getPriceColor } from '../../helpers/auctionColorHelper';
import infoIcon from '../../assets/img/icons/info-primary.svg';

const renderPrice = (valueInPence, fallback = '-') =>
  valueInPence ? preparePriceFormat(pencesToPounds(valueInPence)) : fallback;

function BidsTableRow({ item }) {
  const {
    id,
    bidder,
    bidderLocation,
    seller,
    vehicleMakeName,
    vehicleModelName,
    vehicleYear,
    vehicleRegistrationPlate,
    serial,
    auctionLaunchedOn,
    createdOn,
    autoAcceptPriceInPence,
    highestBidInPence,
    highestProxyBidInPence,
    amountInPence,
    shouldBidAmountBeGreen,
    status,
  } = item;

  const carName = `${vehicleMakeName} ${vehicleModelName}`;
  const bidderFullName = bidder ? `${bidder.firstName} ${bidder.lastName}` : '-';
  const bidColorStyle = getPriceColor(shouldBidAmountBeGreen);
  const displayStatus =
    status === BidStatus.REJECTED
      ? BidStatusName.OFFER_DECLINED.toUpperCase()
      : (BidStatusName[status] ?? status);

  return (
    <>
      <td>{serial}</td>
      <td>{vehicleRegistrationPlate}</td>
      <td>
        {carName} | {vehicleYear}
      </td>
      <td>{dateToString(auctionLaunchedOn)}</td>
      <td>{dateToString(createdOn)}</td>
      <td>{renderPrice(autoAcceptPriceInPence)}</td>
      <td>{renderPrice(highestBidInPence)}</td>
      <td style={bidColorStyle}>{renderPrice(highestProxyBidInPence)}</td>
      <td style={bidColorStyle}>
        <CurrencyFormat
          value={(amountInPence ?? 0) / 100}
          thousandSeparator
          allowNegative={false}
          prefix="£"
          displayType="text"
        />
      </td>
      <td>
        <span id={`seller-tooltip${id}`}>{seller.organization?.tradeName}</span>
        <UncontrolledTooltip
          className="uncontrolled-tooltip"
          delay={0}
          target={`seller-tooltip${id}`}
        >
          {seller.firstName} {seller.lastName} <br />
          {seller.phoneNumber} <br />
          {seller.landingPhoneNumber ?? '-'}
        </UncontrolledTooltip>
      </td>
      <td>
        <span id={`bidder-tooltip${id}`}>{bidder.organization?.tradeName}</span>
        <UncontrolledTooltip
          className="uncontrolled-tooltip"
          delay={0}
          target={`bidder-tooltip${id}`}
        >
          {bidder.firstName} {bidder.lastName} <br />
          {bidder.phoneNumber} <br />
          {bidder.landingPhoneNumber ?? '-'}
        </UncontrolledTooltip>
      </td>
      <td>{formatOrganizationLocation(bidderLocation) || '-'}</td>
      <td>{bidderFullName}</td>
      <td>{displayStatus}</td>
      <td className="text-right">
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip-${id}`}
          size="sm"
        >
          <img src={infoIcon} alt="Info icon" />
        </Button>
        <UncontrolledTooltip
          className="uncontrolled-tooltip"
          delay={0}
          target={`tooltip-${id}`}
        >
          More Details
        </UncontrolledTooltip>
      </td>
    </>
  );
}

export default BidsTableRow;
